import { lazyLoadView } from '@router/routes'

export default [
  // 설명
  {
    path: '/faq',
    component: () => lazyLoadView(import('@views/faq/faq-list.vue')),
    meta: {
      authRequired: true,
    },
  },

  // 설명 상세
  {
    path: '/faq/view',
    component: () => lazyLoadView(import('@views/faq/faq-view.vue')),
    meta: {
      authRequired: true,
    },
  },
]
